import axios from "axios";
import { toggleLoadingData } from "./mutations";

export const axiosError = ({ commit }, payload) => {
  commit("axiosError", payload);
};

export const djangoToken = ({ commit }, payload) => {
  commit("djangoToken", payload);
};

export const addedFriend = ({ commit }, payload) => {
  commit("addedFriend", payload);
};

export const fnfEditData = ({ commit }, payload) => {
  commit("fnfEditData", payload);
};

export const showHideElement = ({ commit }, payload) => {
  commit("showHideElement", payload);
};

export const genericGetApiCall = ({ commit }, payload) => {
  //eslint-disable-next-line no-console
  // console.log(payload);
  commit('toggleLoadingData');
  return new Promise((resolve, reject) => {
    const mutation = payload.mutationName;
    const post_url = payload.url;
    const djangoAuthToken = localStorage.getItem("djangoAccessToken");
    const headers = { headers: { Authorization: "Bearer " + djangoAuthToken } };
    //eslint-disable-next-line no-console
    // console.log(headers);
    
    axios
      .get(post_url, headers)
      .then((response) => {
        // Some components dont need to use the store they just need a once off bit of data
        // If mutation name is null just return the response data as an object in the prommise.
        if (mutation == null) {
          resolve(response.data);
          commit('toggleLoadingData');
        } else {
          commit('toggleLoadingData');
          commit(mutation, response.data);
          resolve(response);
        }
      })
      .catch((error) => {
        var axiosError;
        axiosError = formatError(error);
        commit("axiosError", axiosError);
        commit(toggleLoadingData);
        reject(error);
      });
  });
};

export const genericPostApiCall = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const mutation = payload.mutationName;
    const post_url = payload.url;
    const data = payload.data;
    const djangoAuthToken = localStorage.getItem("djangoAccessToken");
    const headers = { headers: { Authorization: "Bearer " + djangoAuthToken } };
    axios
      .post(post_url, data, headers)
      .then((response) => {
        commit(mutation, response.data);
        resolve(response);
        return;
      })
      .catch((error) => {
        var axiosError;
        axiosError = formatError(error);

        commit("axiosError", axiosError);
        reject(error);
        return;
      });
  });
};

export const genericUpdateApiCall = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const djangoAuthToken = localStorage.getItem("djangoAccessToken");
    const headers = { headers: { Authorization: "Bearer " + djangoAuthToken } };
    const mutation = payload.mutationName;
    const postUrl = payload.url;
    const data = payload.data;
    if (data.image != null) {
      // only patch picture if its changed then remove it altogehter from the object
      // for subsequent itteration to build up form data object
      // creates a new js form data object to allow us to send multipart form data we can patch.
      var fd = new FormData();
      fd.append("picture", data.image, data.imageName);
      //adds our file
      // removes the picture element from the object so there not rebuilt when itterating over fields
      delete data.image;
      delete data.imageName;
      // now itterate over payload.payload to build up the rest of the fields
      for (var item in data) {
        fd.append(item, data[item]);
      }
    } else {
      // there is no picture just send the data as js object
      fd = data;
    }
    axios
      .patch(postUrl, fd, headers)
      .then((response) => {
        // update stored state from response data
        commit(mutation, response.data);
        resolve(response.data);
        return;
      })

      .catch((error) => {
        var axiosError;
        axiosError = formatError(error);

        commit("axiosError", axiosError);
        reject(axiosError);
        return;
      });
  });
};

export const genericDeleteApiCall = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const djangoAuthToken = localStorage.getItem("djangoAccessToken");
    const headers = { headers: { Authorization: "Bearer " + djangoAuthToken } };
    const mutation = payload.mutationName;
    const postUrl = payload.url;
    const id = payload.deletedId;
    axios
      .delete(postUrl, headers)
      .then(() => {
        commit(mutation, id);
        resolve("Deleted Project");
        return;
      })
      .catch((error) => {
        var axiosError;
        axiosError = formatError(error);

        commit("axiosError", axiosError);
        reject("Unable to delete " + error);
        return;
      });
  });
};

export const formatError = (error) => {
  // a function to construct an error object in a standard form for axios update actions to use
  var axiosError;
  if (error.response) {
    // all error codes and data
    axiosError = {
      data: error.response.data,
      headers: error.response.headers,
      status: error.response.status,
    };
  } else if (error.request) {
    // no response was returned to the request
    axiosError = { requestError: true };
  } else {
    // something else happend
    axiosError = { unexpected: error.message };
  }
  return axiosError;
};

export const genericOptionsApiCall = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    // all the below is now promisified
    const djangoAuthToken = localStorage.getItem("djangoAccessToken");
    const headers = { headers: { Authorization: "Bearer " + djangoAuthToken } };
    const mutation = payload.mutationName;
    const post_url = payload.url;
    axios
      .options(post_url, headers)
      .then((response) => {
        commit(mutation, response.data);
        resolve(response);
        return;
      })
      .catch((error) => {
        var axiosError;
        axiosError = formatError(error);

        commit("axiosError", axiosError);
        reject(error);
        return;
      });
    // this is the end of the promise block
  });
};

export const impactPayload = ({ commit }, payload) =>{
  commit('impactPayload',payload);
}